import {
    trackPageViews,
} from "@rtl_nl/rtl-snowplow";
import { globalVars } from "./variables";

/**
 * get the currect environment,
 * prod | acc | dev
 */
function getCurrentEnvironment() {
    const host = window.location.host;
    let environment = 'prod';

    const envs = [
        {
            name: 'acc',
            host: 'blue.msgc.ac',
        },
        {
            name: 'dev',
            host: '.nl.test',
        },
        {
            name: 'prod',
            host: '.com/nl',
        }
    ]

    for (const env of envs) {
        if (host.indexOf(env.host) > -1) {
            environment = env.name;
            break;
        }
    }

    return environment;
}

/**
 * get the current page name
 */
function getPageName() {
    if (window.location.hostname.indexOf('.test') > -1) {
        return `dev-env-${window.location.pathname}`;
    } else if (window.location.pathname == '/nl/') {
        return 'videoland.onboarding.home';
    } else if ( window.location.pathname.indexOf('/titels') > -1 ) {
        const path = window.location.pathname.split('/titels/')[1];
        return `videoland.onboarding.titles.${path.substring(0, path.lastIndexOf('/') !== -1 ? path.lastIndexOf('/') : path.length)}`;
    } else if (window.location.pathname == '/nl/aanbod/') {
        return 'videoland.onboarding.catalogue.index';
    } else {
        const path = window.location.pathname.split('/nl/')[1];
        return `videoland.onboarding.${path.substring(0, path.lastIndexOf('/') !== -1 ? path.lastIndexOf('/') : path.length)}`;
    }
}

/**
 * get page type (home/titel/content)
 */
function getPageType() {
    if (window.location.pathname == '/nl/') {
        return 'Homepage';
    } else if (window.location.pathname.indexOf('/titels') > -1) {
        return 'titlepage';
    } else {
        return 'contentpages'
    }
}

/**
 * get consent categories from window object
 */
function getConsentCategories() {
    const defaultConsent = ['C0001', 'C0002'];

    if (!window.OnetrustActiveGroups) {
        return defaultConsent;
    }

    try {
        return window.OnetrustActiveGroups.split(',').filter((c) => c); // Remove all the empty values.
    } catch (error) {
        return defaultConsent;
    }
}

/**
 * check if an element is in the viewport
 * 
 * @param {el} HTMLelement
 */

function isInViewport(el) {

    const rect = el.getBoundingClientRect();
    const verticalCenter = ( rect.top + rect.bottom ) / 2;
    const horizontalCenter = ( rect.right + rect.left ) / 2;

    if (
        0 <= verticalCenter && verticalCenter <= (window.innerHeight || document.documentElement.clientHeight) &&
        0 <= horizontalCenter &&  horizontalCenter <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
        if (el.getAttribute('in-viewport') === '1') {
            const startTime = parseInt(el.getAttribute('in-viewport-time'), 10);
            const currentTime = Date.now();
            if (((currentTime - startTime) > 700) && el.getAttribute('viewevent-fired') !== '1') {
                el.setAttribute('viewevent-fired', '1');
                return true;
            } else {
                return false;
            }
        } else {
            el.setAttribute('in-viewport', '1');
            el.setAttribute('in-viewport-time', Date.now().toString());
            return false;
        }
    } else {
        if (el.getAttribute('in-viewport') === '1' ) {
            el.removeAttribute('in-viewport');
            el.removeAttribute('in-viewport-time');
            el.removeAttribute('viewevent-fired');
        }
        return false;
    }
}

/**
 * check if an element has height.
 */
function hasHeight(el) {
    if (el.offsetHeight > 10) return true
    return false;
}

/**
 * since some content is loaded dynamically, we need 
 * a function to wait for a specific element
 */
function waitForElm(selector) {
    return new Promise(function (resolve) {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        var observer = new MutationObserver(function (mutations) {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Basic page view tracking
const initiatePageViewTracking = async () => {
    await trackPageViews({
        appId: globalVars.app_id,
        pageName: globalVars.page_name,
    });
};

export {
    getCurrentEnvironment,
    getPageName,
    getPageType,
    getConsentCategories,
    isInViewport,
    initiatePageViewTracking,
    waitForElm,
    hasHeight
}